/* global Search */
import loadFbjsScript from "../../_global/js/fbjsLoader.js";

/**
 * Unified Site Search & Careers Search Engine
 * Consolidates .fbjs-search (main site) and .fbjs-search--careers (careers portal)
 */
const initSiteSearch = async () => {
    const isCareers = !!document.querySelector(".fbjs-search--careers");
    const isGlobal = !isCareers && !!document.querySelector(".fbjs-search");

    if (!isCareers && !isGlobal) return;

    try {
        await loadFbjsScript();
        const mySearch = new Search.default({
        url: "https://wood-search.funnelback.squiz.cloud/s/search.json",
        collections: ["wood~sp-combined-meta"],
        additionalFBparams: {
            profile: "_default",
            nodup: "1",
        },
        onFiltersUpdate: () => {
            const allResultsLabel = document.querySelector(
                ".search__facet-item--all"
            );
            const facetsSelector = document.querySelectorAll(
                ".search__facet-input"
            );
            const facetsLabelsSelector = document.querySelectorAll(
                ".search__facet-label"
            );
            let highlightAllResults = true;
            const checkedParam = 'checked="checked"';

            facetsSelector.forEach((el) => {
                if (el.checked) {
                    highlightAllResults = false;
                }
            });

            const facetTemplateAll = `<label class="search__facet-label">
                <input
                    class="search__facet-input"
                    type="checkbox"
                    value=""
                    name="All results"
                    id="facet--all-results-js"
                    data-fparam="f.section|section"
                    ${highlightAllResults ? checkedParam : ""}
                />
                <span class="search__facet-span">All results</span>
            </label>`;

            if (allResultsLabel) {
                allResultsLabel.innerHTML = facetTemplateAll;

                allResultsLabel.onclick = (e) => {
                    e.preventDefault();
                    const selectedItem = [...facetsSelector].filter(
                        (el) => el.checked
                    );
                    if (selectedItem.length) {
                        selectedItem[0].click();
                    }
                };
            }

            facetsLabelsSelector.forEach((el) => {
                el.onclick = () => {
                    const form = document.querySelector(".search__form");
                    if (form) form.scrollIntoView();
                };
            });
        },
        results: {
            numRanks: 10,
        },
        facets: {
            items: [
                {
                    name: "section",
                    type: "checkbox",
                    options: {
                        singleChoice: true,
                        facetsRestricted: false,
                    },
                },
            ],
        },
        activeFacetsOnStart: {
            "f.Geography|categorisationGeography": [],
            "f.Sectors|categorisationSectors": [],
            "f.Solutions|categorisationSolutions": [],
            "f.section|section": [],
        },
        pagination: {
            loadMore: false,
            arrows: true,
            arrowsOnEdgePages: true,
            dots: false,
            edgePages: false,
            pages: 0,
        },
        templates: {
            articleTemplate: (fields) => {
                const url = fields.clickTrackingUrl
                    ? `https://wood-search.funnelback.squiz.cloud${fields.clickTrackingUrl}`
                    : (fields.liveUrl || fields.displayUrl || "#");
                const rawTitle =
                    fields.listMetadata?.t?.[0] ||
                    fields.listMetadata?.t ||
                    fields.title ||
                    "";
                const title = rawTitle
                    ? `<h2 class="search__item-title">${rawTitle}</h2>`
                    : "";
                const rawDesc =
                    fields.listMetadata?.description?.[0] ||
                    fields.listMetadata?.description ||
                    "";
                const desc = rawDesc
                    ? `<p class="search__item-paragraph">${rawDesc}</p>`
                    : "";
                const breadcrumbs = fields.listMetadata?.breadcrumbs?.[0]
                    ? fields.listMetadata.breadcrumbs[0].replace("Home", "Wood")
                    : "";

                if (rawTitle) {
                    return `
                        <div>
                            <a href="${url}" class="search__item">${title}</a>
                            ${desc}
                            ${breadcrumbs}
                        </div>`;
                }
                return "";
            },
            informationTemplate: (fields, resultsSummary) => `
                <p class="search__summary">
                    Showing ${resultsSummary.currStart}-${resultsSummary.currEnd} of ${resultsSummary.totalMatching}
                </p>`,
            formTemplate: (search, query, inputId) => {
                const cleanQuery = query === "!nullsearch" ? "" : (query || "");
                return `
                    <div>
                        <form class="search__form" role="search" action="/search" method="get">
                            <label for="${inputId}" class="sr-only">Search site</label>
                            <input
                                id="${inputId}"
                                type="text"
                                class="search__form-input search-custom"
                                placeholder="Search..."
                                autocomplete="off"
                                role="searchbox"
                                aria-label="Search"
                                autocorrect="off"
                                autocapitalize="off"
                                spellcheck="false"
                                maxlength="1000"
                                autofocus="autofocus"
                                value="${cleanQuery}">
                            <button type="submit" name="site-search-submit" id="site-search-submit" class="search__submit">
                                <i class="search__submit-icon" aria-hidden="true"></i>
                                <span class="sr-only">Do search</span>
                            </button>
                            <div class="fb-search-wrapper"></div>
                        </form>
                    </div>`;
            },
            paginationNumberTemplate: () => "",
            activePaginationNumberTemplate: () => "",
            arrowNextTemplate: (startrank) =>
                `<button class="btn btn--listing-next" data-startrank=${startrank}>Next</button>`,
            arrowPrevTemplate: (startrank) =>
                `<button class="btn btn--listing-previous" data-startrank=${startrank}>Previous</button>`,
            paginationTemplate: (pages) =>
                `<div class="search__pagination">${pages}</div>`,
            facetCheckbox: (fields, activeFacets) => {
                let list =
                    '<li class="search__facet-item search__facet-item--all"></li>';

                (fields.allValues || []).forEach((item) => {
                    if (item.label !== "other") {
                        const isChecked = activeFacets[
                            "f.section|section"
                        ]?.value?.includes(item.data)
                            ? "checked='checked'"
                            : "";
                        list += `
                            <li class="search__facet-item">
                                <label class="search__facet-label">
                                    <input
                                        class="search__facet-input"
                                        type="checkbox"
                                        ${isChecked}
                                        value="${item.data}"
                                        name="${item.label}"
                                        data-fparam="f.section|section"
                                        data-singlechoice="true"
                                    />
                                    <span class="search__facet-span">${item.label}</span>
                                </label>
                            </li>`;
                    }
                });

                return `
                    <div class="checkbox-facet">
                        <ul class="search__facets">
                            ${list}
                        </ul>
                    </div>`;
            },
            noResults: () =>
                "<div>We're sorry, we couldn't find anything matching.</div>",
        },
    });

        window.mySearch = mySearch;
        mySearch.init();
    } catch (err) {
        console.error("Failed to load Funnelback search client (fbjs):", err);
    }
};

initSiteSearch();
